export default __webpack_public_path__ + "static/media/acct-report-totals.96330b9e.png";